import React, { memo } from 'react'

import { func } from 'prop-types'

import useTranslation from 'Pods/ThreeDStudio/Hooks/useTranslation'
import { useThreeDStudioStore } from 'Pods/ThreeDStudio/Store'

import UpgradeCard from '../UpgradeCard/UpgradeCard'

function HasCreditsBody({ onClose: handleClose }) {
  const t = useTranslation()
  const availableCredits = useThreeDStudioStore(state => state.generation.availableCredits) || 0

  return (
    <div className="usage-modal__has-credits">
      <p className="usage-modal__headline cgt-heading-200">
        {t('usageModal.hasCredits.creditsLeft', { count: availableCredits })}
      </p>

      <UpgradeCard onClose={handleClose} />
    </div>
  )
}

HasCreditsBody.propTypes = {
  onClose: func.isRequired,
}

export default memo(HasCreditsBody)
